module.exports = __webpack_public_path__ + "img/劳动人民文化宫.01a04000.png";